/**
 * MIRA Badge Component
 * Wraps Shadcn Badge with MIRA design system styles
 */

import React from 'react';
import { Badge as ShadcnBadge, badgeVariants } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/data-display/badge.module.css';

export const Badge = React.forwardRef(
  ({ className, variant = 'default', ...props }, ref) => {
    return (
      <ShadcnBadge
        ref={ref}
        variant={variant}
        className={cn(styles.miraBadge, className)}
        {...props}
      />
    );
  }
);

Badge.displayName = 'MiraBadge';

// Re-export badgeVariants for advanced use cases
export { badgeVariants };
